import script from "./AppRiveScene.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRiveScene.vue?vue&type=script&setup=true&lang=js"

import "./AppRiveScene.vue?vue&type=style&index=0&id=b57f4b30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b57f4b30"]])

export default __exports__